import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';

import { Detail } from '../../DetailsPage/Details';

import ComponentConsumptions from './ComponentConsumptions';
import ComponentDescription from './ComponentDescription';
import ComponentVariants from './ComponentVariants/ComponentVariants';

const styles = StyleSheet.create({
  component: {
    display: 'flex',
    border: '1px solid grey',
  },
  componentType: {
    marginTop: 5,
    marginHorizontal: 5,
    ...commonStyles.fontXS,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  componentEmptyState: {
    ...commonStyles.fontS,
  },
});

function ComponentCard({ component, t, productLabels }) {
  const { i18n } = useTranslation();
  return (
    <View style={styles.component} wrap={false}>
      {component.productSnapshot ? (
        <View style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <View style={{ display: 'flex', flexDirection: 'column', width: '30%' }}>
            <Text style={styles.componentType}>
              {i18n.language === 'en'
                ? component.productCategory?.typeLabelEN
                : component.productCategory?.typeLabelPL}
            </Text>
            <Detail title={t('common:name')} description={component.name} />
            <Detail title={t('product_name')} description={component.productSnapshot.name} />
            <ComponentDescription
              productSnapshot={component.productSnapshot}
              productCategory={component.productCategory}
              productLabels={productLabels}
            />
          </View>
          <ComponentConsumptions
            consumptions={component.consumptions}
            consumptionVariedOnSize={component.consumptionVariedOnSize}
            hasPiecesPerMarker={component.productCategory?.hasPiecesPerMarker}
            piecesPerMarker={component.piecesPerMarker}
            productionTimeDays={component.productionTimeDays}
            productCategory={component.productCategory}
            t={t}
            i18n={i18n}
          />
          <ComponentVariants
            colors={component.colors}
            sizes={component.sizes}
            hasOneVariantColorForAllSpecificationColors={
              component.hasOneVariantColorForAllSpecificationColors
            }
            hasOneVariantSizeForAllSpecificationSizes={
              component.hasOneVariantSizeForAllSpecificationSizes
            }
            variantColorForAllSpecificationColors={component.variantColorForAllSpecificationColors}
            variantSizeForAllSpecificationSizes={component.variantSizeForAllSpecificationSizes}
          />
        </View>
      ) : (
        <Text style={styles.componentEmptyState}>{t('no_product_assigned')}</Text>
      )}
    </View>
  );
}

export default withTranslation('specification')(ComponentCard);
